import { makeChartComp } from '../../util/makeChartComp';
var DualAxesChart = makeChartComp('DualAxes');
export default DualAxesChart;
